import React, { useEffect, useState } from 'react';
import { API_URL } from '@/config/api';
import { useSiteLang } from '@/components/site/SiteLang';

/*
  Términos y Condiciones públicos.
  Muestra exactamente la misma versión que el miembro acepta en la plataforma
  (backend/legal/, servida por GET /api/legal/terms). Una sola fuente de verdad.
  En inglés (04/11/2026) solo se traduce el encabezado y se avisa de que el texto vinculante es el español:
  una traducción legal la debe revisar el bufete.
*/
const T = {
  es: { label: 'LOS FUNDAMENTOS', title: 'Términos y Condiciones', version: 'Versión', loading: 'Cargando…', notice: null,
    error: 'No hemos podido cargar los Términos y Condiciones. Escríbenos a info@freedomhomes.club y te los enviamos.' },
  en: { label: 'THE ESSENTIALS', title: 'Terms & Conditions', version: 'Version', loading: 'Loading…',
    notice: 'Our Terms & Conditions are currently published in Spanish only, and the Spanish text is the legally binding version. If anything is unclear, write to info@freedomhomes.club and we’ll happily talk you through it.',
    error: 'We couldn’t load the Terms & Conditions. Write to info@freedomhomes.club and we’ll send them to you.' },
};
const DOC_CLASSES = [
  'text-[15px] leading-relaxed text-slate-700',
  '[&_h1]:text-[#0a1628] [&_h1]:text-lg [&_h1]:font-semibold [&_h1]:mt-10 [&_h1]:mb-3',
  '[&_p]:my-3 [&_strong]:text-[#0a1628] [&_a]:text-[#b8913a] [&_a]:underline',
  '[&_ul]:list-disc [&_ul]:pl-6 [&_li_p]:my-1',
  '[&_table]:w-full [&_table]:my-5 [&_table]:text-sm [&_td]:border [&_th]:border [&_td]:border-slate-200 [&_th]:border-slate-200 [&_td]:px-3 [&_td]:py-2 [&_th]:px-3 [&_th]:py-2 [&_th]:text-left',
].join(' ');

export default function TerminosCondiciones() {
  const { lang } = useSiteLang();
  const t = T[lang] || T.es;
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/legal/terms`).then((r) => (r.ok ? r.json() : Promise.reject())).then(setDoc).catch(() => setError(true));
  }, []);

  return (
    <div className="min-h-screen" style={{ background: 'var(--fhc-off-white, #faf9f6)' }}>
      <section style={{ paddingTop: 140, paddingBottom: 48 }} data-testid="fhc-tc-header">
        <div className="max-w-[760px] mx-auto px-5">
          <p className="fhc-label mb-4">{t.label}</p>
          <h1 className="text-[32px] md:text-[48px] leading-[1.15]" style={{ color: 'var(--fhc-navy, #0a1628)' }}>{t.title}</h1>
          {doc && <p className="mt-3 text-sm text-slate-500">{t.version} {doc.version_label}</p>}
          {t.notice && <p className="mt-5 rounded-lg border border-[#c9a84c]/30 bg-[#c9a84c]/[0.06] px-4 py-3 text-sm leading-relaxed text-slate-600" data-testid="fhc-tc-en-notice">{t.notice}</p>}
          <div className="mt-6 w-14 h-[1px]" style={{ background: 'var(--fhc-gold, #c9a84c)' }} />
        </div>
      </section>
      <section style={{ background: '#fff', padding: '56px 0' }} data-testid="fhc-tc-content">
        <div className="max-w-[760px] mx-auto px-5">
          {error && <p className="text-slate-500">{t.error}</p>}
          {!doc && !error && <p className="text-slate-400">{t.loading}</p>}
          {doc && <div lang="es" className={DOC_CLASSES} dangerouslySetInnerHTML={{ __html: doc.html }} />}
        </div>
      </section>
    </div>
  );
}
